package org.hs_soft.runmynesto.pages.home.sub_page.product.component

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.minHeight
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.silk.components.text.SpanText
import org.hs_soft.runmynesto.domain.config.Dimen
import org.hs_soft.runmynesto.domain.config.FontFamily
import org.hs_soft.runmynesto.domain.config.FontLineHeight
import org.hs_soft.runmynesto.domain.config.FontSizes
import org.hs_soft.runmynesto.domain.config.Theme
import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.domain.model.home.product.ProductInfoHeaderEnum
import org.hs_soft.runmynesto.domain.util.ApiUtils
import org.hs_soft.runmynesto.pages.components.TopTabItems
import org.hs_soft.runmynesto.pages.components.checkout.CheckoutTabContent
import org.hs_soft.runmynesto.pages.home.sub_page.product.component.tabs.allergens_tab.Allergens
import org.hs_soft.runmynesto.pages.home.sub_page.product.component.tabs.price_tab.PriceTabContent
import org.hs_soft.runmynesto.pages.home.sub_page.product.component.tabs.product_general_tab.ProductTabContent
import org.hs_soft.runmynesto.pages.home.sub_page.product.component.tabs.restaurant_tab.RestaurantTabContent
import org.hs_soft.runmynesto.pages.home.sub_page.product.component.tabs.selection.Selection
import org.hs_soft.runmynesto.pages.home.sub_page.product.mvi.ProductEvent
import org.hs_soft.runmynesto.pages.home.sub_page.product.mvi.ProductState
import org.jetbrains.compose.web.css.px

@Composable
fun ProductContent(
    modifier: Modifier = Modifier,
    windowSizeMode: WindowSizeModeEnum,
    state: ProductState,
    onEvent: (ProductEvent) -> Unit,
) {

    Column(
        modifier = modifier
            .fillMaxSize()
            .overflow(Overflow.Auto)
            .margin(
                left =
                if (windowSizeMode== WindowSizeModeEnum.PHONE)
                    0.px
                else Dimen.mediumPadding,
                bottom = Dimen.smallPadding
            ),
        horizontalAlignment = Alignment.Start
    )
    {
        SpanText(
            text=state.selectedProduct?.name?:"",
            modifier = Modifier
                .minHeight(Dimen.minimumContentTitleHeight)
                .fontSize(FontSizes.extraExtraLargeFontSize)
                .fontWeight(FontWeight.Normal)
                .lineHeight(FontLineHeight.lineLarge)
                .color(Theme.TextPrimary.rgb)
                .fontFamily(FontFamily.Jakarta)
        )

        TopTabItems(
            windowSizeMode=windowSizeMode,
            selectedTab=state.selectedTab,
            tabItems = ProductInfoHeaderEnum.entries,
            onTabClick={
                onEvent(ProductEvent.OnTabClick(it))
            }
        )

        when(state.selectedTab)
        {
            ProductInfoHeaderEnum.GENERAL->{
                ProductTabContent(
                    windowSizeMode = windowSizeMode,
                    selectedProduct = state.selectedProduct,
                    selectedSaleGroupId = state.selectedSaleGroupId,
                    salesGroup = state.productSalesGroup,
                    templateCategories = state.templateCategoryList,
                    selectedVat = state.selectedVat,
                    profileCountryId = state.companyProfileId,
                    selectedVat2 = state.selectedVat2,
                    unitSells = state.unitSells,
                    priceLevels=state.priceLevels,
                    event = onEvent
                )
            }
            ProductInfoHeaderEnum.CHECKOUT->{

                CheckoutTabContent(
                    modifier = Modifier,
                    windowSizeMode = windowSizeMode,
                    cashList = state.cashList,
                    cashRegisterIds = state.selectedProduct?.cashRegisterId ?: listOf(),
                    isExpandAll = state.checkOutExpandAll,
                    searchValue = state.checkOutSearchValue,
                    updateCheckout = {
                        onEvent(ProductEvent.UpdateCheckout(it))
                    },
                    onSearchValueChange = {
                        onEvent(ProductEvent.OnSearchCheckoutItems(it))
                    },
                )
            }


            ProductInfoHeaderEnum.PRICE->{
                PriceTabContent(
                    windowSizeMode =windowSizeMode,
                    specialPrices =state.specialPrices,
                    selectedPrice = state.selectedPrice,
                    cashList =state.cashList,
                    priceLevels = state.priceLevels,
                    profileCountryId = state.companyProfileId,
                    checkoutSearchValue=state.checkOutSearchValue,
                    onPriceItemClick = {
                        onEvent(ProductEvent.OnPriceItemClick(it))
                    },
                    onDeletePriceIconClick = {
                        onEvent(ProductEvent.SetDeletePriceDialogStatus(true))
                    },
                    onAddPriceIconClick = {
                        onEvent(ProductEvent.SetAddPriceDialogStatus(true))
                    },
                    onUpdatePriceInfo={title:String,value:dynamic->
                        onEvent(ProductEvent.UpdateSpecialPrice(
                            title =title,
                            value = value,
                        ))
                    },
                    updateCheckout={title:String,it:MutableSet<String> ->
                        onEvent(ProductEvent.UpdateSpecialPrice(
                            title =title,
                            value = it,
                        ))
                    },
                    searchCheckout={
                        onEvent(ProductEvent.OnSearchCheckoutItems(it))
                    },
                    onSearchInPrices={
                        onEvent(ProductEvent.OnSearchInPrices(it))
                    }
                )
            }

            ProductInfoHeaderEnum.SELECTION->{
                Selection(
                    windowSizeMode = windowSizeMode,
                    templateCategoryList=state.templateCategoryList,
                    productSets=state.productSets,
                    priceLevels=state.priceLevels,
                    articles=state.productsInfo,
                    selectedProductSet =state.selectedProductSet,
                    selectedProduct = state.selectedProduct,
                    selectedFixedProductSet = state.selectedFixedProductSet,
                    onProductSetItemClick = {
                        onEvent(ProductEvent.OnProductSetItemClick(id=it))
                    },
                    updateProductSets = {title:String,value:dynamic->
                        onEvent(ProductEvent.UpdateProductSets(
                            title=title,
                            value=value,
                        ))
                    },
                    onSearchInProductSets = {
                        onEvent(ProductEvent.OnSearchInProductSets(
                            searchValue =it
                        ))
                    },
                    onAddProductSetIconClick = {
                        onEvent(
                            ProductEvent.SetCreateNewProductSetDialogStatus(true)
                        )
                    },
                    onDeleteProductSetIconClick = {
                        onEvent(
                            ProductEvent.SetDeleteProductSetDialogStatus(status = true)
                        )
                    },
                    onSearchInFixedProduct={
                        onEvent(
                            ProductEvent.OnSearchInFixedProducts(it)
                        )
                    },
                    onFixedProductClick = {
                        onEvent(
                            ProductEvent.OnFixedProductItemClick(it)
                        )
                    },
                    onAddProductFixIconClick = {
                        onEvent(
                            ProductEvent.SetAddProductFixDialogStatus(status = true)
                        )
                    },
                    onDeleteFixedProductIconClick={
                        onEvent(
                            ProductEvent.SetDeleteFixedProductDialogStatus(true)
                        )
                    },
                    onEditProductFixIconClick = {
                        onEvent(
                            ProductEvent.SetEditProductFixDialogStatus(true)
                        )
                    },
                    updateSelectedProductSet = {
                        onEvent(
                            ProductEvent.UpdateSelectedProductSet(it)
                        )
                    }
                )
            }


            ProductInfoHeaderEnum.RESTAURANT->{

                RestaurantTabContent(
                    selectedProduct = state.selectedProduct,
                    windowSizeMode = windowSizeMode,
                    restaurantData = state.restaurantData,
                    selectedKitchenInfoItem=state.selectedKitchenInfoItem,
                    printerLocation = state.printersLocation,
                    kitchenInfo = state.kitchenInfo,
                    tempItemsDescendingSort = state.restaurantTempItemsDescendingSort,
                    updateIsAdditionRequired = {
                        onEvent(ProductEvent.UpdateRestaurantData(
                            title = ApiUtils.Field.isAdditionRequired,
                            value = it
                        ))
                    },
                    updatePrintOnlyInCafe = {
                        onEvent(ProductEvent.UpdateRestaurantData(
                            title = ApiUtils.Field.isPrintOnlyInCafe,
                            value = it
                        ))
                    },
                    getRestaurantData = {
                        onEvent(ProductEvent.GetRestaurantData)
                    },
                    getPointerLocations = {
                        onEvent(ProductEvent.GetPrinterLocationNames)
                    },
                    updatePrinterLocation = {
                        onEvent(ProductEvent.UpdateRestaurantData(
                            title = ApiUtils.Field.printerLocations,
                            value = it
                        ))
                    },
                    getKitchenInfo = {
                        onEvent(ProductEvent.GetKitchenInfo)
                    },
                    onKitchenInfoTitleSortClick = {
                        onEvent(ProductEvent.OnKitchenInfoTitleClick)
                    },
                    onSearchKitchenInfo = {
                        onEvent(ProductEvent.OnSearchKitchenInfo(it))
                    },
                    onRefreshKitchenInfoClick = {
                        onEvent(ProductEvent.OnRefreshKitchenInfoClick)
                    },
                    activeKitchenInfo = {
                        onEvent(ProductEvent.UpdateRestaurantData(
                            title = ApiUtils.Field.additions,
                            value = listOf(mapOf(ApiUtils.Field.productAddionId to it))
                        ))
                    },
                    deActiveKitchenInfo = {
                        onEvent(ProductEvent.UpdateRestaurantData(
                            title = ApiUtils.Field.additions,
                            value = listOf(mapOf(ApiUtils.Field.id to it))
                        ))
                    },
                    onKitchenInfoItemClick = {
                        onEvent(ProductEvent.OnKitchenInfoItemClick(it))
                    },
                    onAddClick = {
                        onEvent(ProductEvent.OnAddKitchenItemIconClick)
                    },
                    onEditKitchenInfoClick = {
                        onEvent(ProductEvent.OnEditKitchenItemIconClick)
                    },
                    onDeleteKitchenInfoClick = {
                        onEvent(ProductEvent.OnDeleteKitchenItemIconClick)
                    }
                )
            }

//            ProductInfoHeaderEnum.CLICK_AND_CONNECT->{
//                ClickAndCollectTabContent(
//                    windowSizeMode = windowSizeMode,
//                    properties = state.properties,
//                    updateClickAndCollect = { min, max, timeLead ->
//                        onEvent(ProductEvent.UpdateProductProperties(
//                            title = ApiUtils.Field.clickCollectLeadDaysCount,
//                            minOrder = min,
//                            maxOrder = max,
//                            timeLeadDays = timeLead
//                        ))
//                    }
//                )
//            }

            ProductInfoHeaderEnum.ALLERGENES->{
                Allergens(
                    selectedProduct = state.selectedProduct,
                    windowSizeMode = windowSizeMode,
                    ingredients = state.ingredients,
                    showAddNewAlergeneComponent=state.showAddNewAlergeneComponent,
                    checkedIngredients = state.checkedIngredients,
                    onSearchValueChange = {
                        onEvent(ProductEvent.OnSearchIngredientItems(it))
                    },
                    getIngredients = {
                        onEvent(ProductEvent.GetIngredients)
                    },
                    updateAllergenData = { content, ingredientId ->
                        onEvent(ProductEvent.UpdateAllergenContent(
                            content = content,
                            ingredientId = ingredientId
                        ))
                    },
                    getCheckedIngredients = {
                        onEvent(ProductEvent.GetCheckedIngredients)
                    },
                    showCustomAllergenDialogStatus = {
                        onEvent(ProductEvent.SetCreateCustomAlergeneDialogStatus(it))
                    },
                    setCreateAllergenComponentStatus = {
                        onEvent(ProductEvent.SetCreateAlergeneComponentStatus(it))
                    }
                )
            }
        }
    }
}



